<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div id="myModal1" class="modal">
        <span class="close">&times;</span>
        <div class="container-fluid blog py-2">&nbsp;</div>
        <div class="container-fluid blog py-2">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h2 v-if="(bahasa === null) || (bahasa == 'ina')">
                        Detail KPI 1
                    </h2>
                    <h2 v-else>
                        KPI 1 Details
                    </h2>
                    <br>
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.." @click="G_tableCSVTabelKPI1('_DetailKPI1_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </div>
                <div class="col-sm-12 text-center">&nbsp;</div>
                <div class="col-sm-12 text-center">
                    <table class="table m-0" id="tabeldata1" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;">No</th>
                                <th style="width: 250px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Paket
                                    </span>
                                    <span v-else>
                                        Package
                                    </span>
                                </th>
                                <th style="width: 50px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finish
                                    </span>
                                </th>
                                <th style="width: 150px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Kecamatan
                                    </span>
                                    <span v-else>
                                        Subdistrict
                                    </span>
                                </th>
                                <th style="width: 50px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Penduduk
                                    </span>
                                    <span v-else>
                                        Total population
                                    </span>
                                </th>
                                <th style="width: 50px;">KPI 1</th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in kpi1" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td :rowspan="datalist.jml">
                                        {{ urutlist + 1 }}
                                    </td>
                                    <td :rowspan="datalist.jml" class="text-justify">
                                        {{ datalist.Nama_Kegiatan }}
                                    </td>
                                    <td :rowspan="datalist.jml">
                                        {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                    </td>
                                    <td>
                                        {{ datalist.namakecamatan }}
                                    </td>
                                    <td class="text-right">
                                        {{ G_numFormat(datalist.pertama) }}
                                    </td>
                                    <td class="text-right" :rowspan="datalist.jml">
                                        {{ G_numFormat(datalist.nilai) }}
                                    </td>
                                </tr>
                                <tr v-for="(datalain, urutlain) in datalist.detaillain" :key="urutlain">
                                    <td>
                                        {{ datalain.namakecamatan }}
                                    </td>
                                    <td class="text-right">
                                        {{ G_numFormat(datalain.jml) }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tfoot>
                            <tr>
                                <td colspan="5" class="totalkanan">Total</td>
                                <td class="totalkanan">{{ G_numFormat(jumlahtotalkpi1) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div id="myModal7" class="modal">
        <span class="close">&times;</span>
        <div class="container-fluid blog py-2">&nbsp;</div>
        <div class="container-fluid blog py-2">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h2 v-if="(bahasa === null) || (bahasa == 'ina')">
                        Detail KPI 7
                    </h2>
                    <h2 v-else>
                        KPI 7 Details
                    </h2>
                    <br>
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.." @click="G_tableCSVTabelKPI7('_DetailKPI7_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </div>
                <div class="col-sm-12 text-center">&nbsp;</div>
                <div class="col-sm-12 text-center">
                    <table class="table m-0" id="tabeldata1" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;">No</th>
                                <th style="width: 250px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Paket
                                    </span>
                                    <span v-else>
                                        Package
                                    </span>
                                </th>
                                <th style="width: 50px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finish
                                    </span>
                                </th>
                                <th style="width: 150px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Detail Pekerjaan
                                    </span>
                                    <span v-else>
                                        Job Details
                                    </span>
                                </th>
                                <th style="width: 50px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Panjang (km)
                                    </span>
                                    <span v-else>
                                        Length (km)
                                    </span>
                                </th>
                                <th style="width: 50px;">KPI 7</th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in kpi7" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td :rowspan="datalist.jml">
                                        {{ urutlist + 1 }}
                                    </td>
                                    <td :rowspan="datalist.jml" class="text-justify">
                                        {{ datalist.Nama_Kegiatan }}
                                    </td>
                                    <td :rowspan="datalist.jml">
                                        {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                    </td>
                                    <td>
                                        {{ datalist.nama }}
                                    </td>
                                    <td class="text-right">
                                        {{ G_numFormatKoma(datalist.pertama) }}
                                    </td>
                                    <td class="text-right" :rowspan="datalist.jml">
                                        {{ G_numFormatKoma(datalist.nilai) }}
                                    </td>
                                </tr>
                                <tr v-for="(datalain, urutlain) in datalist.detaillain" :key="urutlain">
                                    <td>
                                        {{ datalain.nama }}
                                    </td>
                                    <td class="text-right">
                                        {{ G_numFormatKoma(datalain.jml) }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tfoot>
                            <tr>
                                <td colspan="5" class="totalkanan">Total</td>
                                <td class="totalkanan">{{ G_numFormatKoma(jumlahtotalkpi7) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div id="myModal2" class="modal">
        <span class="close">&times;</span>
        <div class="container-fluid blog py-2">&nbsp;</div>
        <div class="container-fluid blog py-2">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h2 v-if="(bahasa === null) || (bahasa == 'ina')">
                        Detail KPI 2
                    </h2>
                    <h2 v-else>
                        KPI 2 Details
                    </h2>
                    <br>
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.." @click="G_tableCSVTabelKPI2('_DetailKPI2_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </div>
                <div class="col-sm-12 text-center">&nbsp;</div>
                <div class="col-sm-12 text-center">
                    <table class="table m-0" id="tabeldata1" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;">No</th>
                                <th style="width: 50px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Kota
                                    </span>
                                    <span v-else>
                                        City
                                    </span>
                                </th>
                                <th style="width: 50px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun
                                    </span>
                                    <span v-else>
                                        Years
                                    </span>
                                </th>
                                <th style="width: 250px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Peraturan/Kebijakan
                                    </span>
                                    <span v-else>
                                        Regulations/Policies
                                    </span>
                                </th>
                                <th style="width: 250px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Nama Peraturan/Kebijakan
                                    </span>
                                    <span v-else>
                                        Regulations/Policies Name
                                    </span>
                                </th>
                                <th style="width: 150px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah
                                    </span>
                                    <span v-else>
                                        Amount
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in kpi2" :key="urutlist">
                            <tbody>
                                <tr v-for="(datadetail, urutdetail) in datalist.detail" :key="urutdetail">
                                    <td>
                                        {{ urutdetail + 1 }}
                                    </td>
                                    <td class="text-justify">
                                        {{ datadetail.namakota }}
                                    </td>
                                    <td>
                                        {{ datalist.tahun }}
                                    </td>
                                    <td class="text-justify">
                                        {{ datadetail.namaperaturan }}
                                    </td>
                                    <td class="text-justify">
                                        <a :href="datadetail.filenya" target="_blank">{{ datadetail.nama }}</a>
                                    </td>
                                    <td class="text-right">
                                        {{ G_numFormat(datadetail.jumlah) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5" class="levelkegiatan text-right">Sub Total</td>
                                    <td class="levelkegiatan text-right">
                                        {{ G_numFormat(datalist.subtotal) }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tfoot>
                            <tr>
                                <td colspan="5" class="totalkanan">KPI 2</td>
                                <td class="totalkanan">{{ G_numFormat(jumlahtotalkpi2) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s"
                style="font-size: xx-large;">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">KEY PERFORMANCE INDICATOR</span>
                <span v-else>KEY PERFORMANCE INDICATOR</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Key Performance Indicator</span>
                    <span v-else>Key Performance Indicator</span>
                </li>
            </ol>
        </div>
        <br></br><br></br>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid blog py-2">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    INFOGRAFIS KPI
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    KPI INFOGRAPHICS
                </h1>
            </div>
            <div class="row">
                <div class="col-sm-4 text-center"></div>
                <div class="col-sm-4 text-center">
                    <label v-if="(bahasa === null) || (bahasa == 'ina')">
                        Pilihan KPI
                    </label>
                    <label v-else>
                        Choice of KPIs
                    </label>
                    <v-select :options="kpi" :reduce="(label) => label.code" label="label" v-model="defaultSelectedkpi"
                        @update:modelValue="onkpiChange"
                        style="background-color: #ffffff;color: black;z-index: 9999;"></v-select>
                </div>
                <div class="col-sm-4 text-center"></div>
            </div>

        </div>
        <div class="container py-2">
            <div class="col-lg-12 text-center">
                <LineGrafik height="450" :options="chartOptions" :series="series" style="z-index: 1;">
                </LineGrafik>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    REKAPITULASI KPI
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    KPI RECAPITULATION
                </h1>
            </div>
        </div>
        <div class="container py-2">
            <div class="col-sm-12 text-center">
                <a class="hitam">
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_RekapKPI_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </a>
            </div>
            <div class="col-sm-12 text-center">&nbsp;</div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;" rowspan="2">No</th>
                                <th style="width: 50px;" rowspan="2">KPI</th>
                                <th style="width: 220px;" rowspan="2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Indikator
                                    </span>
                                    <span v-else>
                                        Indicator
                                    </span>
                                </th>
                                <th style="width: 50px;" rowspan="2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Satuan
                                    </span>
                                    <span v-else>
                                        Unit
                                    </span>
                                </th>
                                <th style="width: 100px;" rowspan="2" colspan="2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Nilai Awal
                                    </span>
                                    <span v-else>
                                        Initial Value
                                    </span>
                                </th>
                                <th style="width: 50px;" :colspan="colspan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun
                                    </span>
                                    <span v-else>
                                        Years
                                    </span>
                                </th>
                            </tr>
                            <tr>
                                <th v-for="(listtahun, uruttahun) in datatahun">{{ listtahun }}</th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center levelkomponen" colspan="2">{{ urutlist + 1 }}</td>
                                    <td :colspan="colspan2" class="levelkomponen">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.JenisKategori }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.JenisKategori_eng }}
                                        </span>
                                    </td>
                                </tr>
                                <template v-for="(listawp, urutawp) in datalist.Detail" :key="urutawp">
                                    <tr>
                                        <td class="text-center" rowspan="2">{{ urutlist + 1 }}.{{ urutawp + 1 }}</td>
                                        <td rowspan="2"><a href="javascript:void(0)"
                                                @click="bukarekap(listawp.indikator_no)">{{ listawp.indikator_no }}</a>
                                        </td>
                                        <td rowspan="2">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                <a href="javascript:void(0)" @click="bukarekap(listawp.indikator_no)">{{
                                                    listawp.Indikator
                                                }}</a>
                                            </span>
                                            <span v-else>
                                                <a href="javascript:void(0)" @click="bukarekap(listawp.indikator_no)">{{
                                                    listawp.Indikator_eng
                                                }}</a>
                                            </span>
                                        </td>
                                        <td rowspan="2">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                {{ listawp.Satuan }}
                                            </span>
                                            <span v-else>
                                                {{ listawp.Satuan_eng }}
                                            </span>
                                        </td>
                                        <td class="text-center" rowspan="2">{{ listawp.nilaiawal }}</td>
                                        <td class="text-center">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Target
                                            </span>
                                            <span v-else>
                                                Target
                                            </span>
                                        </td>
                                        <td v-for="(listawpchild, urutawpchild,) in listawp.detaildata"
                                            :key="urutawpchild" class="text-center" data-z="#,##0.00">
                                            {{ G_numFormatJikaNumber(listawpchild.target) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Realisasi
                                            </span>
                                            <span v-else>
                                                Realization
                                            </span>
                                        </td>
                                        <td v-for="(listawpchild, urutawpchild,) in listawp.detaildata"
                                            :key="urutawpchild" class="text-center" data-z="#,##0.00">
                                            {{ G_numFormatJikaNumberCapaian(listawpchild.capaian) }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2" style="display: none;">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    DETAIL KPI
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    KPI DETAILS
                </h1>
            </div>
        </div>
        <div class="container py-2">
            <div class="col-sm-12 text-center">
                <a class="hitam">
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel2('_DetailKPI_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </a>
            </div>
            <div class="col-sm-12 text-center">&nbsp;</div>
            <div class="col-sm-12 wow fadeInDown">
                <div class="card cardputih collapsed-card">
                    <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                        <label>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                            <span v-else>Column Filter</span>
                        </label>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body px-3">
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxTahun" value="optionTahun" checked
                                        @click="showColumnTahun = !showColumnTahun">
                                    <label for="customCheckboxTahun" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Tahun
                                        </span>
                                        <span v-else>
                                            Years
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxPelaksana" value="optionPelaksana" checked
                                        @click="showColumnPelaksana = !showColumnPelaksana">
                                    <label for="customCheckboxPelaksana" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Unit Pelaksana
                                        </span>
                                        <span v-else>
                                            Implementation Unit
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxLokasi" value="optionLokasi" checked
                                        @click="showColumnLokasi = !showColumnLokasi">
                                    <label for="customCheckboxLokasi" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Lokasi Kota
                                        </span>
                                        <span v-else>
                                            City Location
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxKegiatan" value="optionKegiatan" checked
                                        @click="showColumnKegiatan = !showColumnKegiatan">
                                    <label for="customCheckboxKegiatan" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Nama Kegiatan
                                        </span>
                                        <span v-else>
                                            Activity Name
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxJenis" value="optionJenis" checked
                                        @click="showColumnJenis = !showColumnJenis">
                                    <label for="customCheckboxJenis" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Jenis Kegiatan
                                        </span>
                                        <span v-else>
                                            Type of activity
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxKomponen" value="optionKomponen" checked
                                        @click="showColumnKomponen = !showColumnKomponen">
                                    <label for="customCheckboxKomponen" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Komponen
                                        </span>
                                        <span v-else>
                                            Component
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxSubKomponen" value="optionSubKomponen" checked
                                        @click="showColumnSubKomponen = !showColumnSubKomponen">
                                    <label for="customCheckboxSubKomponen" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Sub Komponen
                                        </span>
                                        <span v-else>
                                            Sub Component
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2" v-for="(datalist, urutlist) in kpimaster" :key="urutlist">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        :id="urutlist + datalist.showidkpi" :value="'optionKPI' + datalist.showidkpi"
                                        @click="datalist.showidkpi = !datalist.showidkpi" checked>
                                    <label :for="urutlist + datalist.showidkpi" class="custom-control-label">
                                        KPI - {{ datalist.indikator_no }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 wow fadeInDown">
                <div class="card cardputih collapsed-card">
                    <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                        <label>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Data</span>
                            <span v-else>Data Filters</span>
                        </label>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body px-3">
                        <div class="row">
                            <div class="col-sm-3 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unit Pelaksana
                                    </span>
                                    <span v-else>
                                        Implementation Unit
                                    </span>
                                </label>
                                <v-select :options="id_user2" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedid_user2" @update:modelValue="onid_user2Change"
                                    style="background-color: #ffffff;color: black;"></v-select>
                            </div>
                            <div class="col-sm-3 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Lokasi
                                    </span>
                                    <span v-else>
                                        Location
                                    </span>
                                </label>
                                <v-select :options="lokasi2" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedlokasi2" @update:modelValue="onlokasi2Change"
                                    style="background-color: #ffffff;color: black;"></v-select>
                            </div>
                            <div class="col-sm-3 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jenis Kegiatan
                                    </span>
                                    <span v-else>
                                        Type of activity
                                    </span>
                                </label>
                                <v-select :options="jenispekerjaan2" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedjenispekerjaan2"
                                    @update:modelValue="onjenispekerjaan2Change"
                                    style="background-color: #ffffff;color: black;"></v-select>
                            </div>
                            <div class="col-sm-3 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun
                                    </span>
                                    <span v-else>
                                        Years
                                    </span>
                                </label>
                                <v-select :options="tahunmulai2" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedtahunmulai2" @update:modelValue="ontahunmulai2Change"
                                    style="background-color: #ffffff;color: black;"></v-select>
                            </div>
                            <div class="col-sm-3 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Komponen
                                    </span>
                                    <span v-else>
                                        Component
                                    </span>
                                </label>
                                <v-select :options="komponen" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedkomponen" @update:modelValue="onkomponenChange"
                                    style="background-color: #ffffff;color: black;"></v-select>
                            </div>
                            <div class="col-sm-3 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Sub Komponen
                                    </span>
                                    <span v-else>
                                        Sub Component
                                    </span>
                                </label>
                                <v-select :options="subkomponen" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedsubkomponen" @update:modelValue="onsubkomponenChange"
                                    style="background-color: #ffffff;color: black;"></v-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 text-center">&nbsp;</div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata2" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;" rowspan="2">No</th>
                                <th style="width: 50px;" rowspan="2" v-if="showColumnTahun">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun
                                    </span>
                                    <span v-else>
                                        Years
                                    </span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnPelaksana">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unit Pelaksana
                                    </span>
                                    <span v-else>
                                        Implementation Unit
                                    </span>
                                </th>
                                <th style="width: 50px;" rowspan="2" v-if="showColumnLokasi">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Lokasi
                                    </span>
                                    <span v-else>
                                        Location
                                    </span>
                                </th>
                                <th style="width: 250px;" rowspan="2" v-if="showColumnKegiatan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Nama Kegiatan
                                    </span>
                                    <span v-else>
                                        Activity Name
                                    </span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnJenis">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jenis Kegiatan
                                    </span>
                                    <span v-else>
                                        Type of activity
                                    </span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnKomponen">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Komponen
                                    </span>
                                    <span v-else>
                                        Component
                                    </span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnSubKomponen">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Sub Komponen
                                    </span>
                                    <span v-else>
                                        Sub Component
                                    </span>
                                </th>
                                <template v-for="(datalist, urutlist) in kpimaster" :key="urutlist">
                                    <th style="width: 300px;" :colspan="datalist.count" :id="datalist.showidkpi"
                                        v-if="datalist.showidkpi">
                                        KPI - {{ datalist.indikator_no }}
                                        <br>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.nama }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.nama_eng }}
                                        </span>
                                    </th>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(datalist, urutlist) in kpimaster" :key="urutlist">
                                    <th style="width: 300px;" :id="datalist.showidkpi"
                                        v-for="(datalistindikator, urutlistindikator) in datalist.indikator"
                                        :key="urutlistindikator" v-if="datalist.showidkpi">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalistindikator.indikator }}
                                        </span>
                                        <span v-else>
                                            {{ datalistindikator.indikator_eng }}
                                        </span>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <template v-for="(datalistutama, urutlist) in datamaster2" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ urutlist + 1 }}</td>
                                    <td class="text-center" v-if="showColumnTahun">{{ datalistutama.tahunselesai }}</td>
                                    <td class="text-justify" v-if="showColumnPelaksana">{{ datalistutama.nama_satker }}
                                    </td>
                                    <td class="text-justify" v-if="showColumnLokasi">{{ datalistutama.namalokasi }}</td>
                                    <td class="text-justify" v-if="showColumnKegiatan">{{ datalistutama.Nama_Kegiatan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnJenis">{{ datalistutama.Kategori }}</td>
                                    <td class="text-center" v-if="showColumnKomponen">{{ datalistutama.Komponen }}</td>
                                    <td class="text-center" v-if="showColumnSubKomponen">{{ datalistutama.SubKomponen }}
                                    </td>
                                    <template v-for="(datalist, urutlist) in kpimaster" :key="urutlist">
                                        <template v-for="(datalistutama, urutlistdetail) in datalistutama.DataKPI"
                                            :key="urutlistdetail">
                                            <td class="text-center" :id="'detail' + datalistutama.showidkpi"
                                                v-for="(datalistdetaildata, urutlistdetaildata) in datalistutama.nilai"
                                                :key="urutlistdetaildata"
                                                v-if="(datalist.showid == datalistutama.showid) && datalist.showidkpi"
                                                :data-v="datalistdetaildata.nilai" data-z="#,##0">
                                                {{ datalistdetaildata.nilai }}
                                            </td>
                                        </template>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->

    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "OpenSans-Regular, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, vSelect, LineGrafik: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datamaster2: [],
            kpimaster: [],
            carikata: '',
            colspan: 0,
            colspan2: 0,
            datatahun: [],
            ekportexcel: [],
            ekportexcel1: [],
            ekportexcel2: [],

            id_user2: [],
            dataid_user2: [],
            defaultSelectedid_user2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user2: '',

            lokasi2: [],
            datalokasi2: [],
            defaultSelectedlokasi2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi2: '',

            jenispekerjaan2: [],
            datajenispekerjaan2: [],
            defaultSelectedjenispekerjaan2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan2: '',

            tahunmulai2: [],
            datatahunmulai2: [],
            defaultSelectedtahunmulai2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai2: '',


            kpi: [],
            datakpi: [],
            defaultSelectedkpi: {
                code: 0,
                label: 'Semua KPI',
                tag: '',
            },
            selectedkpi: '',

            komponen: [],
            datakomponen: [],
            defaultSelectedkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedkomponen: '',

            subkomponen: [],
            datasubkomponen: [],
            defaultSelectedsubkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedsubkomponen: '',

            showColumnTahun: true,
            showColumnPelaksana: true,
            showColumnLokasi: true,
            showColumnKegiatan: true,
            showColumnJenis: true,
            showColumnKomponen: true,
            showColumnSubKomponen: true,
            series: [],

            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: true
                    }
                },
                colors: ['#77B6EA', '#ADFF2F'],
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        if (isNaN(val)) {
                            return '';
                        }
                        else {
                            return val.toFixed(2).toString().replaceAll(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        }
                    },
                    offsetY: -5,
                    style: {
                        fontSize: '8px',
                        colors: ['#5c6165', '#ff7f00'],
                    }
                },
                stroke: {
                    curve: 'smooth'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    title: {
                        text: 'Tahun'
                    }
                },
                yaxis: {
                    title: {
                        text: 'Nilai KPI'
                    },
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2).toString().replaceAll(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        }
                    },
                },
                legend: {
                    position: 'bottom',
                    show: true,
                }
            },

            project_id: process.env.VUE_APP_PROJECT_ID,
            jumlahtotalkpi1: 0,
            jumlahtotalkpi7: 0,
            jumlahtotalkpi2: 0,
            kpi1: [],
            kpi7: [],
            kpi2: [],
        };
    },
    methods: {
        async G_tableCSVTabelKPI1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationunduhkpi1-KPI?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabelKPI7(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationunduhkpi7-KPI?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabelKPI2(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationunduhkpi2-KPI?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async bukarekap(indikator) {
            //alert(indikator);
            var random = Math.random();
            if (indikator == 1) {
                this.kpi1 = [];
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    },
                });
                await mainAPI.get("parastapainnovationtabelkpi-1?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user2 + "&lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen=" + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.kpi1 = [];
                        this.jumlahtotalkpi1 = 0;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.halamanloading = true;
                            this.kpi1 = Response.data.content.data;
                            this.jumlahtotalkpi1 = Response.data.content.jumlahtotal;
                            //alert(JSON.stringify(this.datamaster2));
                            var modal = document.getElementById("myModal1");
                            // Get the image and insert it inside the modal - use its "alt" text as a caption
                            modal.style.display = "block";
                            //modalImg.src = img.src;
                            //captionText.innerHTML = img.alt;

                            // Get the <span> element that closes the modal
                            var span = document.getElementsByClassName("close")[0];

                            // When the user clicks on <span> (x), close the modal
                            span.onclick = function () {
                                modal.style.display = "none";
                            }
                            this.halamanloading = false;
                        }
                        else {
                            this.datapesan = '';
                            this.kpi1 = [];
                            //alert(this.datapesan);
                            this.halamanloading = false;

                        }
                    }
                ).catch(error => {
                    this.datapesan = '';
                    this.kpimaster = [];
                    this.datamaster2 = [];
                    this.halamanloading = false;
                });

                return;
            }
            if (indikator == 7) {
                this.kpi7 = [];
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    },
                });
                await mainAPI.get("parastapainnovationtabelkpi-7?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user2 + "&lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen=" + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.kpi7 = [];
                        this.jumlahtotalkpi7 = 0;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.halamanloading = true;
                            this.kpi7 = Response.data.content.data;
                            this.jumlahtotalkpi7 = Response.data.content.jumlahtotal;
                            //alert(JSON.stringify(this.datamaster2));
                            var modal = document.getElementById("myModal7");
                            // Get the image and insert it inside the modal - use its "alt" text as a caption
                            modal.style.display = "block";
                            //modalImg.src = img.src;
                            //captionText.innerHTML = img.alt;

                            // Get the <span> element that closes the modal
                            var span = document.getElementsByClassName("close")[1];

                            // When the user clicks on <span> (x), close the modal
                            span.onclick = function () {
                                modal.style.display = "none";
                            }
                            this.halamanloading = false;
                        }
                        else {
                            this.datapesan = '';
                            this.kpi7 = [];
                            //alert(this.datapesan);
                            this.halamanloading = false;

                        }
                    }
                ).catch(error => {
                    this.datapesan = '';
                    this.kpimaster = [];
                    this.datamaster2 = [];
                    this.halamanloading = false;
                });

                return;
            }
            if (indikator == 2) {
                this.kpi2 = [];
                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    },
                });
                await mainAPI.get("parastapainnovationtabelkpi-2?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user2 + "&lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen=" + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.kpi2 = [];
                        this.jumlahtotalkpi2 = 0;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.halamanloading = true;
                            this.kpi2 = Response.data.content.data;
                            this.jumlahtotalkpi2 = Response.data.content.jumlahtotal;
                            //alert(JSON.stringify(this.datamaster2));
                            var modal = document.getElementById("myModal2");
                            // Get the image and insert it inside the modal - use its "alt" text as a caption
                            modal.style.display = "block";
                            //modalImg.src = img.src;
                            //captionText.innerHTML = img.alt;

                            // Get the <span> element that closes the modal
                            var span = document.getElementsByClassName("close")[2];

                            // When the user clicks on <span> (x), close the modal
                            span.onclick = function () {
                                modal.style.display = "none";
                            }
                            this.halamanloading = false;
                        }
                        else {
                            this.datapesan = '';
                            this.kpi2 = [];
                            //alert(this.datapesan);
                            this.halamanloading = false;

                        }
                    }
                ).catch(error => {
                    this.datapesan = '';
                    this.kpimaster = [];
                    this.datamaster2 = [];
                    this.halamanloading = false;
                });

                return;
            }
            else {
                swal.fire('Peringatan', 'Export gagal: ' + 'injection detected', 'error');
            }
        },
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkpi-KPI?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkpi-Detail?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user2 + "&lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen=" + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        onid_user2Change(a) {
            try {
                this.selectedid_user2 = this.id_user2[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunmulai2Change(a) {
            try {
                this.selectedtahunmulai2 = this.tahunmulai2[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasi2Change(a) {
            try {
                this.selectedlokasi2 = this.lokasi2[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi2);
            this.ambildata();
        },
        onjenispekerjaan2Change(a) {
            try {
                this.selectedjenispekerjaan2 = this.jenispekerjaan2[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan2)
            this.ambildata();

            //alert(this.selectedjenispekerjaan2);
        },
        onkpiChange(a) {
            try {
                this.selectedkpi = this.kpi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedkpi)
            this.rubahdatagrafik();

            //alert(this.selectedkpi);
        },
        onkomponenChange(a) {
            try {
                this.selectedkomponen = this.komponen[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedkomponen)
            this.getsubkomponen();

            //alert(this.selectedkomponen);
        },
        onsubkomponenChange(a) {
            try {
                this.selectedsubkomponen = this.subkomponen[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
            //alert(this.selectedsubkomponen)
            //this.rubahdatagrafik();

            //alert(this.selectedsubkomponen);
        },
        async rubahdatagrafik() {
            this.halamanloading = true;
            this.series = [];
            for (let i = 0; i < this.datamaster.length; i++) {
                for (let x = 0; x < this.datamaster[i].Detail.length; x++) {
                    var detaildatatarget = [];
                    var detaildatacapaian = [];

                    for (let c = 0; c < this.datamaster[i].Detail[x].detaildata.length; c++) {
                        var target = this.datamaster[i].Detail[x].detaildata[c].target;
                        if (target == 'Ya / Yes') {
                            target = 100;
                        }
                        if (target == 'Tidak / No') {
                            target = 0;
                        }
                        var capaian = this.datamaster[i].Detail[x].detaildata[c].capaian;
                        if (capaian == 'Ya / Yes') {
                            capaian = 100;
                        }
                        else if (capaian == 'Tidak / No') {
                            capaian = 0;
                        }
                        else {
                            if (c == 0) {
                                capaian = capaian;
                            }
                            else {
                                capaian = capaian;
                                //capaian = parseInt(capaian) + parseInt(detaildatacapaian[c - 1]);
                            }
                        }
                        if (target == 'NaN') {
                            target = 0;
                        }
                        detaildatatarget.push(target);
                        if (capaian == 'NaN') {
                            capaian = null;
                        }
                        if (capaian != 'NaN') {
                            detaildatacapaian.push(capaian);
                        }


                        //alert(detaildatacapaian[detaildatacapaian.length-1]);
                    }
                    //alert(detaildatacapaian);
                    if (this.selectedkpi != '') {
                        if (this.selectedkpi == this.datamaster[i].Detail[x].indikator_no) {
                            this.series.push({
                                name: 'Target KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                data: detaildatatarget,
                            });
                            this.series.push({
                                name: 'Capaian KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                data: detaildatacapaian,
                            });
                        }
                    }
                    else {
                        this.series.push({
                            name: 'Target KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                            data: detaildatatarget,
                        });
                        this.series.push({
                            name: 'Capaian KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                            data: detaildatacapaian,
                        });
                    }

                }
            }
            //alert(detaildatacapaian);
            this.halamanloading = false;
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationreffmonitoring-UserProject?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user2 = [];
                        this.id_user2 = [];
                        this.dataid_user2 = Response.data.content.data;
                        this.dataid_user2.forEach((item) => {
                            this.id_user2.push({
                                label: item.nama_satker,
                                code: this.dataid_user2.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedid_user2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.id_user2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedid_user2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.id_user2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi2 = [];
                        this.lokasi2 = [];
                        this.datalokasi2 = Response.data.content.data;
                        this.datalokasi2.forEach((item) => {
                            this.lokasi2.push({
                                label: item.nama,
                                code: this.datalokasi2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedlokasi2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.lokasi2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedlokasi2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.lokasi2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-JenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan2 = [];
                        this.jenispekerjaan2 = [];
                        this.datajenispekerjaan2 = Response.data.content.data;
                        this.datajenispekerjaan2.forEach((item) => {
                            this.jenispekerjaan2.push({
                                label: item.nama,
                                code: this.datajenispekerjaan2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedjenispekerjaan2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.jenispekerjaan2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedjenispekerjaan2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.jenispekerjaan2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-TahunProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahunmulai2 = [];
                        this.tahunmulai2 = [];
                        this.datatahunmulai2 = Response.data.content.data;
                        this.datatahunmulai2.forEach((item) => {
                            this.tahunmulai2.push({
                                label: item.tahun,
                                code: this.datatahunmulai2.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunmulai2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunmulai2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunmulai2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunmulai2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datakomponen = [];
                        this.komponen = [];
                        this.datakomponen = Response.data.content.data;
                        this.datakomponen.forEach((item) => {
                            this.komponen.push({
                                label: item.nama,
                                code: this.datakomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.komponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.komponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    else {
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //this.halamanloading = true;

        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    else {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            this.ambildata();
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-KPI?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    this.colspan = Response.data.jumlahtahun;
                    this.colspan2 = (this.colspan * 2) - 1;
                    //alert(this.colspan);

                    //alert(this.datatahun);
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.halamanloading = true;
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datatahun);
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptions = {
                                xaxis: {
                                    title: {
                                        text: 'Tahun'
                                    },
                                    categories: this.datatahun,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Nilai KPI'
                                    },
                                    labels: {
                                        formatter: function (value) {
                                            return value.toFixed(2).toString().replaceAll(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                        }
                                    },
                                },
                            };
                        }
                        else {
                            this.chartOptions = {
                                xaxis: {
                                    title: {
                                        text: 'Years'
                                    },
                                    categories: this.datatahun,
                                },
                                yaxis: {
                                    title: {
                                        text: 'KPI values'
                                    },
                                    labels: {
                                        formatter: function (value) {
                                            return value.toFixed(2).toString().replaceAll(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                        }
                                    },
                                },
                            };
                        }


                        this.series = [];
                        this.kpi = [];
                        for (let i = 0; i < this.datamaster.length; i++) {
                            for (let x = 0; x < this.datamaster[i].Detail.length; x++) {
                                var detaildatatarget = [];
                                var detaildatacapaian = [];
                                this.kpi.push({
                                    label: 'KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                    code: this.datamaster[i].Detail[x].indikator_no,
                                    tag: this.datamaster[i].Detail[x].indikator_no,
                                });

                                for (let c = 0; c < this.datamaster[i].Detail[x].detaildata.length; c++) {
                                    var target = this.datamaster[i].Detail[x].detaildata[c].target;
                                    if (target == 'Ya / Yes') {
                                        target = 100;
                                    }
                                    if (target == 'Tidak / No') {
                                        target = 0;
                                    }
                                    var capaian = this.datamaster[i].Detail[x].detaildata[c].capaian;
                                    if (capaian == 'Ya / Yes') {
                                        capaian = 100;
                                    }
                                    else if (capaian == 'Tidak / No') {
                                        capaian = 0;
                                    }
                                    else {
                                        if (c == 0) {
                                            capaian = capaian;
                                        }
                                        else {
                                            capaian = capaian;
                                            //capaian = parseInt(capaian) + parseInt(detaildatacapaian[c - 1]);
                                        }
                                    }
                                    if (target == 'NaN') {
                                        target = 0;
                                    }
                                    detaildatatarget.push(target);
                                    if (capaian == 'NaN') {
                                        capaian = null;
                                    }
                                    detaildatacapaian.push(capaian);

                                    //alert(detaildatacapaian[detaildatacapaian.length-1]);
                                }
                                //alert(detaildatacapaian);

                                if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                                    this.series.push({
                                        name: 'Target KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                        data: detaildatatarget,
                                    });
                                    this.series.push({
                                        name: 'Capaian KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                        data: detaildatacapaian,
                                    });
                                }
                                else {
                                    this.series.push({
                                        name: 'Targets KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                        data: detaildatatarget,
                                    });
                                    this.series.push({
                                        name: 'Achievements KPI - ' + this.datamaster[i].Detail[x].indikator_no,
                                        data: detaildatacapaian,
                                    });
                                }
                                //alert(detaildatacapaian);
                            }
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedkpi = {
                                code: 0,
                                label: 'Semua KPI',
                                tag: '',
                            };
                            this.kpi.unshift({
                                label: 'Semua KPI',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedkpi = {
                                code: 0,
                                label: 'All KPI',
                                tag: '',
                            };
                            this.kpi.unshift({
                                label: 'All KPI',
                                code: 0,
                                tag: '',
                            });
                        }
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.colspan = 0;
                        this.colspan2 = 0;
                        this.datatahun = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.colspan = 0;
                this.colspan2 = 0;
                this.datatahun = [];
                this.halamanloading = false;
            });

            this.halamanloading = true;

            await mainAPI.get("parastapainnovationmonitoring-DetailDataKPI?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user2 + "&lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen=" + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster2 = [];
                    this.kpimaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.halamanloading = true;
                        this.datapesan = [];
                        this.datamaster2 = Response.data.content.data[0].Content;
                        this.kpimaster = Response.data.content.data[0].KPImaster;
                        //alert(JSON.stringify(this.datamaster2));
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.kpimaster = [];
                        this.datamaster2 = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.kpimaster = [];
                this.datamaster2 = [];
                this.halamanloading = false;
            });
            //this.halamanloading = true;
        },
    },
    mounted() {
        this.ambildatareff();
        this.ambildata();
    },
}
</script>

<style></style>